module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Shovel-17d03fd6941727434de7646a1d33c615.svg";